export default "__VITE_PUBLIC_ASSET__03520646__"